// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"295":"cfc9ad3f","376":"ed36c339","527":"68fdbe00"}[chunkId] + ".css";
};